module.exports = __webpack_public_path__ + "img/bad.434cb623.png";